import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from '../actions';
import { loadSingleArticle, unloadSingleArticle } from '../actions/discover.actions';

import './stylings/DiscoverArticle.css';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner.component';

export class DiscoverArticle extends React.Component {
	componentDidMount() {
		if (this.props.match.params.articleName) {
			this.props.loadSingleArticle(this.props.match.params.articleName);
		}
	}

	componentWillUnmount() {
		this.props.unloadSingleArticle();
	}

	renderTextBody() {
		let paragraphs = [];

		this.props.selectedArticle.acf.text.map((element, i) => {
			paragraphs.push(<p className="article-paragraph" key={i}>{element.text}</p>);
		});

		return paragraphs;
	}

	renderOpeningHours() {
		let openingHours = [];

		this.props.selectedArticle.acf.openingHours.map((element, i) => {
			openingHours.push(
				<div>
					<span>{element.day}: {element.time}</span><br/>
				</div>
			);
		});
		return openingHours;
	}

	render() {
		if (!this.props.articleIsLoaded) {
			return <LoadingSpinner />;
		}

		if (!this.props.selectedArticle) {
			return <Redirect to="/404"/>;
		}

		const paragraphs = this.renderTextBody();
		const openingHours = this.renderOpeningHours(); 

		return (
			<section className="single-portfolio animated fadeIn">
			
				<div className="article-cover-image" style={{backgroundImage: `url(${this.props.selectedArticle.acf.backgroundImage})`}}>
					<div className="article-cover-title-container">
						<h1 className="article-cover-title">{this.props.selectedArticle.title.rendered}</h1>
						<h2 className="article-cover-subtitle">{this.props.selectedArticle.acf.heading}</h2>
						<h2 className="article-cover-subtitle">Ein Text von {this.props.selectedArticle.acf.guestauthor}</h2>
					</div>	
				</div>
				<div className="container">
					<div className="section-inner no-border">
						<div className="row">
						
							<div className="col-xlarge-9 single-portfolio-left">
								<div className="page-content">
									{paragraphs}
								</div>
							</div>
							
							<div className="col-xlarge-3">
								<div className="right-sidebar">
									<div className="detail-block">
										<h3>Adresse</h3>
										<span>{this.props.selectedArticle.acf.street}</span><br/>
										<span>{this.props.selectedArticle.acf.postcode}</span><br/>
										<span>{this.props.selectedArticle.acf.city}</span><br/>
									</div>
									
									<div className="detail-block">
										<h3>Webseite</h3>
										<a href={this.props.selectedArticle.acf.website}>{this.props.selectedArticle.acf.website}</a>
									</div>
									
									<div className="detail-block">
										<h3>Öffnungszeiten</h3>
										{openingHours}
									</div>
								</div>
							</div>
						
						</div>
					</div>
				</div>
			</section>
		);
	}
}


const mapStateToProps = ({discover}) => {
	return {
		selectedArticle: discover.get('selectedArticle'),
		articleIsLoaded: discover.get('articleIsLoaded')
	};
};

const mapDispatchToProps = dispatch => ({
	loadSingleArticle: compose(dispatch, loadSingleArticle),
	unloadSingleArticle: compose(dispatch, unloadSingleArticle)
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverArticle);


// WEBPACK FOOTER //
// ./src/containers/DiscoverArticle.js